import React, { lazy } from "react";
import authRoute from "./authRoute";
// import { lazy } from "configs/lazy";

export const publicRoutes = [
  ...authRoute,

  // {
  //   key: "assets",
  //   path: "/assets/*",
  //   component: lazy(() => import("")),
  //   authority: [],
  // },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: "/dashboard",
    component: lazy(() => import("views/Dashboard")),
    authority: [],
  },
  {
    key: "getStarted",
    path: "/get-started",
    component: lazy(() => import("views/GetStarted")),
    authority: [],
  },
  {
    key: "myProjects",
    path: "studio/projects",
    component: lazy(() => import("views/MyProjects")),
    authority: [],
  },
  {
    key: "project",
    path: "studio/projects/:projectID",
    component: lazy(() => import("views/MyProjects/Project")),
    authority: [],
  },
  {
    key: "customer",
    path: "/service-bots",
    component: lazy(() => import("views/CustomerService")),
    authority: [],
  },
  {
    key: "customer",
    path: "/service-bot",
    component: lazy(() => import("views/CustomerService/Details")),
    authority: [],
  },
  {
    key: "project",
    path: "studio/projects/:projectID/visualization",
    component: lazy(() => import("views/MyProjects/DataVisualization")),
    authority: [],
  },
  {
    key: "otherService",
    path: "/qore",
    component: lazy(() => import("views/OtherServices")),
    authority: [],
  },
  {
    key: "chatgpt",
    path: "/qore/chatgpt-dialogue",
    component: lazy(() => import("views/OtherServices/pages/ChatGPT")),
    authority: [],
  },
  {
    key: "computerVision",
    path: "/qore/computer-vision",
    component: lazy(() => import("views/OtherServices/pages/DetectLiveliness")),
    authority: [],
  },

  {
    key: "SpeechToText",
    path: "/qore/speech-to-text",
    component: lazy(() => import("views/OtherServices/pages/SpeechToText")),
    authority: [],
  },
  {
    key: "Detect-liveliness",
    path: "/qore/liveliness-detection",
    component: lazy(() => import("views/OtherServices/pages/DetectLiveliness")),
    authority: [],
  },
  {
    key: "CompareFaces",
    path: "/qore/compare-faces",
    component: lazy(() => import("views/OtherServices/pages/CompareFaces")),
    authority: [],
  },
  {
    key: "Face on the web",
    path: "/qore/detect-face-owner",
    component: lazy(() => import("views/OtherServices/pages/DetectFaceOnWeb")),
    authority: [],
  },
  {
    key: "textToImage",
    path: "/qore/text-to-image",
    component: lazy(() => import("views/OtherServices/pages/TextToImage")),
    authority: [],
  },
  {
    key: "textToSpeech",
    path: "/qore/text-to-speech",
    component: lazy(() => import("views/OtherServices/pages/TextToSpeech")),
    authority: [],
  },
  {
    key: "translateAi",
    path: "/qore/translate-ai",
    component: lazy(() => import("views/OtherServices/pages/TranslateAi")),
    authority: [],
  },
  {
    key: "videoAi",
    path: "/qore/video-ai",
    component: lazy(() => import("views/OtherServices/pages/VideoAi")),
    authority: [],
  },
  {
    key: "VisionAi",
    path: "/qore/vision-ai",
    component: lazy(() => import("views/OtherServices/pages/VisionApi")),
    authority: [],
  },
  {
    key: "ObjectInImage",
    path: "/qore/objects-in-image",
    component: lazy(() => import("views/OtherServices/pages/ObjectInImage")),
    authority: [],
  },
  {
    key: "DetectText",
    path: "/qore/text-in-image",
    component: lazy(() => import("views/OtherServices/pages/TextInImage")),
    authority: [],
  },
  {
    key: "DetectLandmark",
    path: "/qore/landmark-detection",
    component: lazy(() =>
      import("views/OtherServices/pages/LandmarkDetection")
    ),
    authority: [],
  },
  {
    key: "DetecLogo",
    path: "/qore/detect-logo",
    component: lazy(() => import("views/OtherServices/pages/DetectLogo")),
    authority: [],
  },
  {
    key: "DetectLabel",
    path: "/qore/labels-in-image",
    component: lazy(() => import("views/OtherServices/pages/LabelInImage")),
    authority: [],
  },
  {
    key: "detect-faces",
    path: "/qore/detect-faces",
    component: lazy(() => import("views/OtherServices/pages/DetectFaces")),
    authority: [],
  },
  {
    key: "Detect-age-and-gender",
    path: "/qore/detect-age-and-gender",
    component: lazy(() =>
      import("views/OtherServices/pages/DetectAgeAndGender")
    ),
    authority: [],
  },
  {
    key: "stable-diffusion",
    path: "/qore/image-generation",
    component: lazy(() => import("views/OtherServices/pages/StableDiffusion")),
    authority: [],
  },
  {
    key: "voice-cloning",
    path: "/qore/voice-cloning",
    component: lazy(() => import("views/OtherServices/pages/VoiceCloning")),
    authority: [],
  },
  {
    key: "bart-text-summary",
    path: "/qore/bart-text-summary",
    component: lazy(() =>
      import("../../views/OtherServices/pages/TextSummary")
    ),
    authority: [],
  },
  {
    key: "image-captioning",
    path: "/qore/image-captioning",
    component: lazy(() =>
      import("../../views/OtherServices/pages/ImageCaptioning")
    ),
    authority: [],
  },
  {
    key: "WhisperAi",
    path: "/qore/whisper-ai",
    component: lazy(() => import("../../views/OtherServices/pages/WhisperAi")),
    authority: [],
  },
  {
    key: "Resnet-18",
    path: "/qore/resnet-18",
    component: lazy(() => import("../../views/OtherServices/pages/Resnet18")),
    authority: [],
  },
  {
    key: "Document-qa",
    path: "/qore/document-qa",
    component: lazy(() => import("../../views/OtherServices/pages/DocumentQa")),
    authority: [],
  },
  {
    key: "Distill-bert",
    path: "/qore/text-classification",
    component: lazy(() =>
      import("../../views/OtherServices/pages/DistillBert")
    ),
    authority: [],
  },
  {
    key: "Resnet-50",
    path: "/qore/resnet-50",
    component: lazy(() => import("../../views/OtherServices/pages/Resnet50")),
    authority: [],
  },
  {
    key: "Visual Question and Answering",
    path: "/qore/visual-question-answer",
    component: lazy(() =>
      import("views/OtherServices/pages/VisualQuestionAnswering")
    ),
    authority: [],
  },
  {
    key: "datasets",
    path: "/datasets",
    component: lazy(() => import("views/DataSets")),
    authority: [],
  },
  {
    key: "competitions",
    path: "/studio/competitions",
    component: lazy(() => import("views/competitions/CompetitionList")),
    authority: [],
  },
  {
    key: "competitions-submissions",
    path: "/studio/competitions/:slug",
    component: lazy(() => import("views/competitions/Submissions")),
    authority: [],
  },
  {
    key: "studioWizard",
    path: "/studio/projects/wizard",
    component: lazy(() => import("views/WizardStudio/index")),
    authority: [],
    meta: {
      layout: "blank",
    },
  },
  {
    key: "studio2",
    path: "/studio2",
    component: lazy(() => import("views/Studio/index.tsx")),
    authority: [],
    meta: {
      layout: "blank",
    },
  },
  {
    key: "studioLabelCraft",
    path: "/studio/projects/label-craft",
    component: lazy(() => import("views/LabelCraft")),
    authority: [],
    meta: {
      layout: "blank",
    },
  },
  {
    key: "aiWidget",
    path: "/studio/projects/edit",
    component: lazy(() => import("views/MyProjects/AIWidget")),
    authority: [],
    meta: {
      layout: "blank",
    },
  },

  {
    key: "settings",
    path: "/settings",
    component: lazy(() => import("views/Settings")),
    authority: [],
  },

  {
    key: "billing",
    path: "/billing",
    component: lazy(() => import("views/Billing")),
    authority: [],
  },
  {
    key: "changeBilling",
    path: "/billing/change-plan",
    component: lazy(() => import("views/Billing/ChangeBilling")),
    authority: [],
  },
  {
    key: "billngSuccess",
    path: "/billing/success",
    component: lazy(() => import("views/Billing/BillingSuccess")),
    authority: [],
  },
  {
    key: "audit",
    path: "/audit",
    component: lazy(() => import("views/Audit")),
    authority: [],
  },
  {
    key: "quickPrediction",
    path: "/quick-predikt",
    component: lazy(() => import("views/QuickPrediction")),
    authority: [],
  },
  {
    key: "ecommerce",
    path: "/marketplace",
    component: lazy(() => import("views/Ecommerce")),
    authority: [],
  },
  {
    key: "Manage market ",
    path: "/marketplace/manage",
    component: lazy(() => import("views/Ecommerce/ManageProducts")),
    authority: [],
  },
  {
    key: "wallet-success",
    path: "/marketplace/success",
    component: lazy(() => import("views/Ecommerce/FundSuccess")),
    authority: [],
  },
  {
    key: "product",
    path: "/marketplace/:id",
    component: lazy(() => import("views/Ecommerce/Product")),
    authority: [],
  },
  {
    key: "privacyPolicy",
    path: "/privacy-policy",
    component: lazy(() => import("views/PrivacyPolicy")),
    authority: [],
  },
  {
    key: "termandconditions",
    path: "/terms-and-conditions",
    component: lazy(() => import("views/TermsAndConditions")),
    authority: [],
  },
  {
    key: "notFound",
    path: "*",
    component: lazy(() => import("views/NotFound")),
    authority: [],
  },
  {
    key: "comingSoon",
    path: "/coming-soon",
    component: lazy(() => import("views/ComingSoon")),
    authority: [],
  },
  {
    key: "chatbots",
    path: "/chatbots",
    component: lazy(() => import("views/Chatbots")),
    authority: [],
  },
  {
    key: "chatbot",
    path: "/chatbots/chatbot/:chatbotID",
    component: lazy(() => import("views/Chatbots/Chatbot")),
    authority: [],
  },
  {
    key: "genesis",
    path: "/genesis",
    component: lazy(() => import("views/Genesis")),
    authority: [],
    meta: {
      pageContainerType: "gutterless",
    },
  },
  {
    key: "customer-service",
    path: "/genesis/customer-service",
    component: lazy(() => import("views/Genesis/Pages/CustomerService")),
    authority: [],
  },
  // {
  //   key: "genesis",
  //   path: "/genesis/:serviceId",
  //   component: lazy(() => import("views/Genesis")),
  //   authority: [],
  // },
];
